import { useApiQuery } from "hooks/useApiQuery/useApiQuery";
import { CACHE_KEYS } from "commons/constants";
import { renderErrorNotifications } from "helpers/error.helpers";
import useActivitiesMasterData from "hooks/useActivitiesMasterData/useActivitiesMasterData";
import useGeoMasterData from "hooks/useGeoMasterData/useGeoMasterData";

/**
 * Loads activity, what-we-do, and geo master data lists.
 * Returns select-ready options and lookup helpers for community flows.
 */
export default function useCommunityMasterData() {
  const { activities, activityOptions, isFetching: isFetchingActivities } =
    useActivitiesMasterData();

  const {
    cities,
    areas,
    cityOptions,
    getAreaOptions,
    getCityName,
    getAreaDisplayName,
    isFetching: isFetchingGeo,
  } = useGeoMasterData();

  const { data: whatWeDoData, isFetching: isFetchingWhatWeDo } = useApiQuery({
    queryKey: CACHE_KEYS.WHAT_WE_DO_MASTER_LIST,
    url: "v1/community-portal/master-data/what-we-do-master/list",
    params: { page_size: 10000, current_page: 1 },
    staleTimeInMinutes: 30,
    onError: (errors) => renderErrorNotifications(errors),
  });

  const whatWeDo = whatWeDoData?.data ?? [];

  return {
    activities,
    activityOptions,
    whatWeDo,
    cities,
    areas,
    cityOptions,
    getAreaOptions,
    getCityName,
    getAreaDisplayName,
    loadingGeo: isFetchingGeo,
    loading:
      isFetchingActivities || isFetchingWhatWeDo || isFetchingGeo,
  };
}
